var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-responsive',{attrs:{"aspect-ratio":4/4}},[_c('v-skeleton-loader',{staticClass:"fill-width fill-height align-self-stretch",attrs:{"type":'image',"height":"100%"}}),_c('v-icon',{staticClass:"empty-icon"},[_vm._v("mdi-cart")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }